/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TRemoveOffersFromFolderRequest,
  TRemoveOffersFromFolderModel,
  IMappers,
  TRemoveOffersFromFolderResponse,
  TRemoveOffersFromFolderResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createRemoveOffersFromFolderModel(
  parameters: TRemoveOffersFromFolderRequest,
): TRemoveOffersFromFolderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/remove-offers-from-folder/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IRemoveOffersFromFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TRemoveOffersFromFolderRequest;
}

export async function fetchRemoveOffersFromFolder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRemoveOffersFromFolderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TRemoveOffersFromFolderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createRemoveOffersFromFolderModel(parameters),
    config,
  )) as FetchResponse<TRemoveOffersFromFolderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TRemoveOffersFromFolderResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TRemoveOffersFromFolderResponse>;
}
